import { useEffect, useState } from "react";
import { FormatedType, UseDataProps } from "./types";

export default function useData({ ids, requestItem, formatItem }: UseDataProps) {
  const [selectedItems, setSelectedItems] = useState<FormatedType[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!ids?.length || selectedItems?.length) return;
    setLoading(true);
    const request = ids.map((id: number) => requestItem(id));

    Promise.all(request)
      .then((res) => {
        const resData = res.map(formatItem).filter((item) => item);
        setSelectedItems(resData);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, [ids]);

  return { selectedItems, setSelectedItems, loading };
}
